import { render, staticRenderFns } from "./MarketingBlockEdit.vue?vue&type=template&id=70dcb186&scoped=true"
import script from "./MarketingBlockEdit.vue?vue&type=script&lang=js"
export * from "./MarketingBlockEdit.vue?vue&type=script&lang=js"
import style0 from "./MarketingBlockEdit.vue?vue&type=style&index=0&id=70dcb186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dcb186",
  null
  
)

export default component.exports